// extracted by mini-css-extract-plugin
module.exports = {"total":"Total_total__3oj25","rating":"Total_rating__1oZ1i","label":"Total_label__2KAkK","customers":"Total_customers__Dgf9b"};